import { Injectable } from '@angular/core';

import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})
export class CyberSourceService {
    private isScriptLoaded = false;
    private flexInstance: any;
    private microform: any;

    async init(captureContext: string): Promise<void> {
        await this.loadScript(captureContext);

        if (typeof (window as any).Flex !== 'undefined') {
            this.flexInstance = new (window as any).Flex(captureContext);
            this.microform = this.flexInstance.microform();
        }
    }

    private async loadScript(captureContext: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.isScriptLoaded) {
                resolve();

                return;
            }

            const decoded = jwtDecode(captureContext);
            const decodedAny = decoded as any;

            const script = document.createElement('script');
            script.src = decodedAny.ctx[0].data.clientLibrary;
            script.integrity = decodedAny.ctx[0].data.clientLibraryIntegrity;
            script.crossOrigin = 'anonymous';
            script.async = true;
            script.onload = () => {
                this.isScriptLoaded = true;

                resolve();
            };
            script.onerror = () => reject(new Error('Error al cargar Microform'));

            document.body.appendChild(script);
        });
    }

    createField(fieldType: 'number' | 'securityCode', idContainer: string, styles: any): any {
        if (this.microform) {
            const field = this.microform.createField(fieldType, styles);
            field.load(`#${idContainer}`);

            return field;
        }
    }

    async createToken(expirationMonth: string, expirationYear: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (this.microform) {
                const options = {
                    expirationMonth,
                    expirationYear
                };
                void this.microform.createToken(options,  function(err: any, token: any): void {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(token);
                    }
                });
            }
        });
    }
}
